import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.parcels || initialState;

const makeSelectList = () =>
  createSelector(select, subState => subState.parcelsList);

const makeSelectParcel = () =>
  createSelector(select, subState => subState.parcel);
const makeSelectLogs = () => createSelector(select, subState => subState.logs);

const makeSelectCountList = () =>
  createSelector(select, subState => subState.count);
const makeSelectLocatedCardCountList = () =>
  createSelector(select, subState => subState.locatedCardCount);
const makeSelectSubmmitedCardCountList = () =>
  createSelector(select, subState => subState.submittedCardCount);
const makeSelectProgressCardCountList = () =>
  createSelector(select, subState => subState.progressCardCount);
const makeSelectConflictCardCountList = () =>
  createSelector(select, subState => subState.conflictCardCount);

const makeSelectInventoryItemsList = () =>
  createSelector(select, subState => subState.inventoryItems);

const makeSelectInventoryItemsCount = () =>
  createSelector(select, subState => subState.inventoryItemsCount);

const makeSelectAllParcels = () =>
  createSelector(select, subState => subState.allParcelsReport);

const makeSelectInventoryItemsLoading = () =>
  createSelector(select, subState => subState.inventoryItemsLoading);

const makeSelectInventoryItemsError = () =>
  createSelector(select, subState => subState.inventoryItemsError);

const makeSelectInventoryItemsWithSerialList = () =>
  createSelector(select, subState => subState.inventoryItemsWithSerial);

const makeSelectInventoryItemsWithSerialLoading = () =>
  createSelector(select, subState => subState.inventoryItemsWithSerialLoading);

const makeSelectInventoryItemsWithSerialError = () =>
  createSelector(select, subState => subState.inventoryItemsWithSerialError);

const makeSelectInventoryItemsWithStatusList = () =>
  createSelector(select, subState => subState.inventoryItemsWithStatus);

const makeSelectInventoryItemsWithStatusLoading = () =>
  createSelector(select, subState => subState.inventoryItemsWithStatusLoading);

const makeSelectInventoryItemsWithStatusError = () =>
  createSelector(select, subState => subState.inventoryItemsWithStatusError);

const makeSelectLoading = () =>
  createSelector(select, subState => subState.loading);

const makeSelectError = () =>
  createSelector(select, subState => subState.error);

export default select;
export {
  makeSelectList,
  makeSelectParcel,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectSubmmitedCardCountList,
  makeSelectLocatedCardCountList,
  makeSelectProgressCardCountList,
  makeSelectConflictCardCountList,
  makeSelectError,
  makeSelectLogs,
  makeSelectInventoryItemsList,
  makeSelectInventoryItemsCount,
  makeSelectInventoryItemsLoading,
  makeSelectInventoryItemsError,
  makeSelectInventoryItemsWithSerialList,
  makeSelectInventoryItemsWithSerialLoading,
  makeSelectInventoryItemsWithSerialError,
  makeSelectInventoryItemsWithStatusList,
  makeSelectInventoryItemsWithStatusLoading,
  makeSelectInventoryItemsWithStatusError,
  makeSelectAllParcels,
};
